import React, { Component } from "react";
import SocialShareButtons from "./SocialShareButtons";
import Modal from "../../../components/Modal";
import ShareForm from "../../../shared/how_use/ShareForm.jsx";
import ComponentHasTranslations from "../../../utils/component_has_translations";

class ShareActions extends Component {
  share_modal_id = "share_modal";

  render = () => {
    return (
      <>
        <div className="share_actions">
          <div className="info">
            <div className="row row-cols-6 gx-2">
              <div
                className="col-6"
                dangerouslySetInnerHTML={{
                  __html: this.tr("share_box.share.text"),
                }}
              />
              <div
                className="col-6"
                dangerouslySetInnerHTML={{
                  __html: this.tr("share_box.donate.text"),
                }}
              />
            </div>
          </div>

          <div className="row gx-1">
            <div className="col-6">
              <button
                className="btn btn-happy"
                data-bs-toggle="modal"
                data-bs-target={`#${this.share_modal_id}`}
              >
                <i className="fa fa-comment" />{" "}
                {this.tr("share_box.share.btn_text")}
              </button>
            </div>

            <div className="col-6">
              <form
                action="https://www.paypal.com/cgi-bin/webscr"
                method="post"
                target="_blank"
              >
                <input type="hidden" name="cmd" value="_s-xclick" />
                <input
                  type="hidden"
                  name="hosted_button_id"
                  value="MLXPWC3696LXS"
                />
                <button id="donate" type="submit" className="btn btn-red">
                  ❤ {this.tr("share_box.donate.btn_text")}
                </button>
                <img
                  alt=""
                  border="0"
                  src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif"
                  width="1"
                  height="1"
                />
              </form>
            </div>

            <div className="col-12">
              <SocialShareButtons />
            </div>
          </div>
        </div>
        <Modal modal_id={this.share_modal_id}>
          <ShareForm context={"tap_app"} tr={this.props.tr || {}} />
        </Modal>
      </>
    );
  };
}

Object.assign(ShareActions.prototype, ComponentHasTranslations);
export default ShareActions;
